import { useState } from 'react';

import { DrawerViewType } from '../types';

export const useHubDrawerState = () => {
  const [selectedHubId, setSelectedHubId] = useState<string | null>(null);

  const open = (hubId: string) => setSelectedHubId(hubId);
  const close = () => setSelectedHubId(null);

  return {
    selectedHubId,
    view: DrawerViewType.Hub,
    open,
    close,
  };
};
